import { CustomSearchParams } from "@/components/common/deep-link/deep-link-encoding";
import { removeSearchParam } from "@/components/common/deep-link/deep-link-utils";
import { ReactComponent as RegisterSuccessSvg } from "@/components/ui/icons/register-success.svg";
import { WorkflowDialog } from "@faro-lotv/data-management";
import { FaroButton } from "@faro-lotv/flat-ui";
import { ReactNode, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * @returns Modal dialog with a success message that gets shown when the ?showRegisterSuccess=true
 *          URL search parameter is provided for successfully registering the project.
 */
export function RegisterSuccessDialog(): ReactNode {
  const [searchParams] = useSearchParams();
  const show = searchParams.has(CustomSearchParams.showRegisterSuccess);
  const [isOpen, setIsOpen] = useState(show);

  if (show) {
    // Remove the no longer needed URL search parameter.
    removeSearchParam(CustomSearchParams.showRegisterSuccess);
  }

  return (
    <WorkflowDialog
      variant="notice"
      open={isOpen}
      title="Ready for review"
      description="You can now check the results and review everything before publishing."
      image={RegisterSuccessSvg}
      actions={
        <FaroButton
          // Set the focus on the button so that the dialog can also be closed with the Return key,
          // but remove the ugly default border around the button.
          autoFocus
          sx={{
            "&.MuiButton-root:focus-visible": {
              boxShadow: "none",
              outline: "none",
            },
          }}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Let's start
        </FaroButton>
      }
    />
  );
}
